import React, {useEffect, useState} from "react";
import {Paper, Typography, Box} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {styled} from "@mui/material/styles";
import {useAuth} from "../sdk";
import {useLocation} from "react-router-dom";

const NotificationPopup = () => {
  const location = useLocation();
  const {notification, showNotification} = useAuth();
  const [isNotification, setIsNotification] = useState(false);

  const allowedRoutes = ["/channel-comparison", "/price-checker"];
  const isAllowedRoute = allowedRoutes.some((routePath) =>
    location.pathname.includes(routePath)
  );

  useEffect(() => {
    if (notification && showNotification && isAllowedRoute) {
      setIsNotification(true);

      const timer = setTimeout(() => {
        setIsNotification(false);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [notification, location.pathname, showNotification, isAllowedRoute]);

  if (!isNotification || !notification || !isAllowedRoute) return null;

  return (
    <NotificationWrapper>
      <StyledPaper elevation={4}>
        <InfoOutlinedIcon sx={{fontSize: 28}} />
        <StyledText>{notification}</StyledText>
      </StyledPaper>
    </NotificationWrapper>
  );
};

export default NotificationPopup;

const NotificationWrapper = styled(Box)(({ theme }) => ({
  position: "fixed",
  top: 20,
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 1300,
}));

const StyledPaper = styled(Paper)(({theme}) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.5),
  backgroundColor: "#ffffffe5",
  color: "#ff0000ff",
  padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
  borderRadius: "12px",
  maxWidth: "100%",
  backdropFilter: "blur(4px)",
}));

const StyledText = styled(Typography)(() => ({
  lineHeight: 1.4,
  fontSize: 14,
  fontWeight: 500
}));
